<template>
	<div ref="noticeCreate" class="dialog-container">
		<div class="dialog" style="max-height: 560px; transform: translate(0, -280px);">
			<form @submit.stop="doValidation()">
				<div class="top">
					<p class="txt-crud-title">
						Notice Create
					</p>
				</div>
				<div class="center">
					<table class="tb-crud-horizon">
						<colgroup>
							<col width="15%" />
							<col width="85%" />
						</colgroup>
						<tbody>
							<tr>
								<th>Title.</th>
								<td>
									<input
										type="text"
										class="input-crud"
										name="noticeName"
										v-model="item.noticeName"
										v-validate="'required'"
										data-vv-as="Notice Name"
									/>
									<p class="txt-validation" v-if="errors.has('noticeName')">
										* {{ errors.first("noticeName") }}
									</p>
								</td>
							</tr>
							<tr>
								<th>Regist Date.</th>
								<td>{{ item.firstRegistDate }}</td>
							</tr>
							<tr>
								<th>Register.</th>
								<td>{{ userInfo.userName }} ({{ userInfo.userId }})</td>
							</tr>
							<tr>
								<th>Contents.</th>
								<td>
									<textarea
										class="textarea-crud"
										name="noticeContents"
										v-model="item.noticeContents"
										v-validate="'required'"
										data-vv-as="Notice Contents"
									></textarea>
									<p class="txt-validation" v-if="errors.has('noticeContents')">
										* {{ errors.first("noticeContents") }}
									</p>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="bottom">
					<button type="button" class="btn-save fright" title="Save" @click.stop="doValidation()">
						Save
					</button>
					<button type="button" class="btn-cancel fright" title="Cancel" @click="doCancel()">
						Cancel
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import EventBus from "@/script/EventBus.js";
import moment from "moment";

export default {
	name: "NoticeCreate",
	created() {
		this.logger.debug(this, "created()");
		this.item.firstRegistDate = moment().format("YYYY-MM-DD");
	},
	data() {
		return {
			item: {}
		};
	},
	methods: {
		doValidation() {
			this.logger.debug(this, "doValidation()");
			this.$validator
				.validateAll()
				.then((result) => {
					this.logger.debug(this, "doValidationResult:" + result);
					if (result)
					{
						this.$confirm("Do you want to register the current notice?","Question","question").then(() => {
							this.doInsert();
						});
					}
				})
				.catch(() => {
					this.logger.debug(this, "-->" + this.errors.all());
					alert(this.errors.all());
					return false;
				});
		},
		doInsert() {
			this.logger.debug(this, "doInsert()");
			axios
				.post(this.config.contextRoot + "/notice/insertNotice.do", this.item)
				.then((response) => {
					if (response.status == 200)
					{
						console.log(response);
						location.reload();
					}
					else
					{
						alert(response);
						console.log(response);
					}
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doCancel() {
			this.logger.debug(this, "doCancel()");
			this.$confirm("Do you want to cancel the notice registration?","Question","question").then(() => {
				this.doClose();
			});
		},
		doClose() {
			this.logger.debug(this, "doClose()");
			this.$refs.noticeCreate.style.animation = "fadeOut 0.4s ease-in-out both";
			this.$refs.noticeCreate.children[0].style.animation = "fadeOutDrop 0.4s ease-in-out both";
			setTimeout(function() {
				EventBus.$emit("notice-cancel", "isCreate");
			}.bind(this), 410);
		}
	}
};
</script>

<style scoped>
.btn-cancel {
	margin-right: 10px;
}
</style>